<div
  #buttonWrapper
  class="flex"
  [class.click-area]="!disabled"
  [class.center]="buttonCentered"
  [class.cursor-pointer]="!disabled"
  (click)="!disabled ? openMenu(false, $event) : null"
>
  <div #button class="opener" [class.w-full]="fullwidth"><ng-content select="[button]"></ng-content></div>

  @if (!button.innerHTML.trim()) {
    <div class="center menu-button flex" [class.active]="open ? 'active' : ''">
      <button [ngClass]="[buttonClasses, buttonExtra]"><i class="icon-{{ icon }}"></i></button>
      @if (text) {
        <div class="text">{{ text }}</div>
      }
    </div>
  }
</div>

<ng-template #template>
  <div
    #popup
    cdkScrollable
    class="popup-menu {{ showOverflow ? 'show-overflow' : null }}"
    [ngClass]="pointerClasses"
    [ngStyle]="menuStyle"
    (click)="closeOnClicking()"
  >
    @if (relative) {
      <div #pointer class="indicator" [ngStyle]="pointerStyle"></div>
    }
    <div class="popup-header" #header [class.hide]="!header.innerHTML.trim()"><ng-content select="[header]"></ng-content></div>
    <div
      class="popup-content"
      [ngStyle]="overlayStyle"
      [style.paddingTop.px]="(draggable && !preventDragStyle) || closeButton ? 20 : 0"
      resizeObserver
      (resize)="reposition()"
    >
      <ng-content></ng-content>
    </div>

    @if ((draggable && !preventDragStyle) || closeButton) {
      <div class="popup-controls flex">
        @if (draggable && !preventDragStyle) {
          <div class="handle" title="Drag me">
            <i class="icon-move"></i>
          </div>
        }
        @if (closeButton) {
          <div class="popup-close-button cursor-pointer" (click)="closeAction()" title="Close me">
            <i class="icon-cancel-1"></i>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
